import { render, staticRenderFns } from "./SugestaoWebAmbiente.vue?vue&type=template&id=4ad981e6&scoped=true&lang=pug"
import script from "./SugestaoWebAmbiente.vue?vue&type=script&lang=js"
export * from "./SugestaoWebAmbiente.vue?vue&type=script&lang=js"
import style0 from "./SugestaoWebAmbiente.vue?vue&type=style&index=0&id=4ad981e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad981e6",
  null
  
)

export default component.exports